var _mask, _rect, _mask2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesDeduplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 17,
    height: 17,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 17,
    height: 17,
    rx: 1,
    stroke: "#2968C9",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 1,
    fill: "#EEF4FF",
    stroke: "#2968C9",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesDeduplicate);
export default __webpack_public_path__ + "static/media/pipelines-deduplicate.ced335c87411734e960df78da6af00a0.svg";
export { ForwardRef as ReactComponent };